// extracted by mini-css-extract-plugin
export var active = "_uv-1";
export var circle = "_uv-0";
export var completed = "_uv-2";
export var connector = "_uv-4";
export var connectorCompleted = "_uv-7";
export var connectorSpacer = "_uv-5";
export var iconStrokeOverride = "_uv-8";
export var labelContainer = "_uv-6";
export var pending = "_uv-3";